import {css} from 'lit';
export const styles = css`:host {
  /* use !important to prevent issues with browser extensions that change fonts */
  font-family: 'icomoon' !important; /* stylelint-disable-line */
  speak: never; /* stylelint-disable-line */
  font-style: normal;
  font-weight: normal;
  font-feature-settings: normal;
  font-variant: normal;
  text-transform: none;
  line-height: 1;

  /* Better Font Rendering =========== */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

:host([name='user-headset'])::before {
  content: '\\e9c8';
}

:host([name='user-headset-s'])::before {
  content: '\\e9c9';
}

:host([name='cake-candles'])::before {
  content: '\\e9c7';
}

:host([name='screen-users'])::before {
  content: '\\e9c2';
}

:host([name='building'])::before {
  content: '\\e9c3';
}

:host([name='chevron-down'])::before {
  content: '\\e9aa';
}

:host([name='chevron-left'])::before {
  content: '\\e9ab';
}

:host([name='chevron-right'])::before {
  content: '\\e9ac';
}

:host([name='chevron-up'])::before {
  content: '\\e9ad';
}

:host([name='globe'])::before {
  content: '\\e9a9';
}

:host([name='apple-alt'])::before {
  content: '\\e900';
}

:host([name='android'])::before {
  content: '\\e99d';
}

:host([name='phone-laptop'])::before {
  content: '\\e99e';
}

:host([name='file-alt'])::before {
  content: '\\e993';
}

:host([name='file-audio'])::before {
  content: '\\e994';
}

:host([name='file-archive'])::before {
  content: '\\e995';
}

:host([name='file-image'])::before {
  content: '\\e996';
}

:host([name='file-pdf'])::before {
  content: '\\e997';
}

:host([name='file-video'])::before {
  content: '\\e998';
}

:host([name='file-plus'])::before {
  content: '\\e999';
}

:host([name='file-times1'])::before {
  content: '\\e99a';
}

:host([name='file-times'])::before {
  content: '\\e97c';
}

:host([name='at'])::before {
  content: '\\e992';
}

:host([name='key'])::before {
  content: '\\e991';
}

:host([name='smile'])::before {
  content: '\\e990';
}

:host([name='mobile'])::before {
  content: '\\e98e';
}

:host([name='rss'])::before {
  content: '\\e98c';
}

:host([name='blog'])::before {
  content: '\\e98d';
}

:host([name='chart-network'])::before {
  content: '\\e98b';
}

:host([name='beunity'])::before {
  content: '\\e98a';
}

:host([name='chart-pie'])::before {
  content: '\\e989';
}

:host([name='ballot'])::before {
  content: '\\e988';
}

:host([name='scrubber'])::before {
  content: '\\e97f';
}

:host([name='handshake'])::before {
  content: '\\e963';
}

:host([name='thumbtack'])::before {
  content: '\\e962';
}

:host([name='thumbtack-s'])::before {
  content: '\\e91e';
}

:host([name='toggle-off'])::before {
  content: '\\e956';
}

:host([name='toggle-on'])::before {
  content: '\\e957';
}

:host([name='share-alt'])::before {
  content: '\\e901';
}

:host([name='share'])::before {
  content: '\\e955';
}

:host([name='copy'])::before {
  content: '\\e951';
}

:host([name='external-link'])::before {
  content: '\\e952';
}

:host([name='calendar-alt'])::before {
  content: '\\e950';
}

:host([name='calendar-plus'])::before {
  content: '\\e9a5';
}

:host([name='calendar-minus'])::before {
  content: '\\e9a6';
}

:host([name='calendar-check'])::before {
  content: '\\e9a4';
}

:host([name='calendar-times'])::before {
  content: '\\e9a7';
}

:host([name='calendar-day'])::before {
  content: '\\e9ae';
}

:host([name='volume'])::before {
  content: '\\e92a';
}

:host([name='shopping-basket'])::before {
  content: '\\e947';
}

:host([name='bullhorn'])::before {
  content: '\\e948';
}

:host([name='times-circle'])::before {
  content: '\\e934';
}

:host([name='close'])::before {
  content: '\\e908';
}

:host([name='check-circle'])::before {
  content: '\\e961';
}

:host([name='check'])::before {
  content: '\\e90a';
}

:host([name='check-double'])::before {
  content: '\\e90d';
}

:host([name='plus-circle'])::before {
  content: '\\e92d';
}

:host([name='plus-circle-s'])::before {
  content: '\\e933';
}

:host([name='plus'])::before {
  content: '\\e935';
}

:host([name='minus-circle'])::before {
  content: '\\e932';
}

:host([name='plus-minus-s'])::before {
  content: '\\e936';
}

:host([name='minus'])::before {
  content: '\\e95c';
}

:host([name='spinner-third'])::before {
  content: '\\e943';
}

:host([name='shield-check'])::before {
  content: '\\e94e';
}

:host([name='bell'])::before {
  content: '\\e904';
}

:host([name='bell-s'])::before {
  content: '\\e91d';
}

:host([name='bells'])::before {
  content: '\\e9ce';
}

:host([name='bell-on'])::before {
  content: '\\e9cf';
}

:host([name='bookmark'])::before {
  content: '\\e905';
}

:host([name='bookmark-s'])::before {
  content: '\\e928';
}

:host([name='clock'])::before {
  content: '\\e907';
}

:host([name='pencil'])::before {
  content: '\\e902';
}

:host([name='trash-alt'])::before {
  content: '\\e97d';
}

:host([name='delete'])::before {
  content: '\\e90c';
}

:host([name='trash-restore-alt'])::before {
  content: '\\e931';
}

:host([name='sign-out-alt'])::before {
  content: '\\e910';
}

:host([name='eye'])::before {
  content: '\\e912';
}

:host([name='eye-s'])::before {
  content: '\\e9cb';
}

:host([name='newspaper'])::before {
  content: '\\e92f';
}

:host([name='folder'])::before {
  content: '\\e960';
}

:host([name='clipboard-user'])::before {
  content: '\\e903';
}

:host([name='portrait'])::before {
  content: '\\e906';
}

:host([name='user'])::before {
  content: '\\e98f';
}

:host([name='user-plus'])::before {
  content: '\\e909';
}

:host([name='user-friends'])::before {
  content: '\\e984';
}

:host([name='users'])::before {
  content: '\\e980';
}

:host([name='group-add'])::before {
  content: '\\e919';
}

:host([name='human-greeting'])::before {
  content: '\\e91c';
}

:host([name='star'])::before {
  content: '\\e93d';
}

:host([name='star-s'])::before {
  content: '\\e924';
}

:host([name='heart'])::before {
  content: '\\e91b';
}

:host([name='heart-s'])::before {
  content: '\\e925';
}

:host([name='lock-alt'])::before {
  content: '\\e90b';
}

:host([name='lock-open-alt'])::before {
  content: '\\e90e';
}

:host([name='user-lock'])::before {
  content: '\\e90f';
}

:host([name='user-lock-o'])::before {
  content: '\\e9d0';
}

:host([name='sliders'])::before {
  content: '\\e954';
}

:host([name='filter'])::before {
  content: '\\e913';
}

:host([name='sort'])::before {
  content: '\\e922';
}

:host([name='menu'])::before {
  content: '\\e923';
}

:host([name='list-ul'])::before {
  content: '\\e940';
}

:host([name='comment-lines'])::before {
  content: '\\e929';
}

:host([name='comment-lines-s'])::before {
  content: '\\e92b';
}

:host([name='comment-alt-lines'])::before {
  content: '\\e959';
}

:host([name='comment-alt-lines-s'])::before {
  content: '\\e92e';
}

:host([name='comment-alt-plus'])::before {
  content: '\\e930';
}

:host([name='comment-alt-exclamation'])::before {
  content: '\\e927';
}

:host([name='comments-alt'])::before {
  content: '\\e9b0';
}

:host([name='clipboard-list'])::before {
  content: '\\e95b';
}

:host([name='ban'])::before {
  content: '\\e95a';
}

:host([name='ban-s'])::before {
  content: '\\e9ca';
}

:host([name='exclamation-triangle'])::before {
  content: '\\e911';
}

:host([name='info-circle'])::before {
  content: '\\e914';
}

:host([name='question-circle'])::before {
  content: '\\e92c';
}

:host([name='ellipsis-h'])::before {
  content: '\\e915';
}

:host([name='image'])::before {
  content: '\\e916';
}

:host([name='broken-image'])::before {
  content: '\\e99b';
}

:host([name='map-marker-alt'])::before {
  content: '\\e917';
}

:host([name='reply'])::before {
  content: '\\e937';
}

:host([name='save'])::before {
  content: '\\e939';
}

:host([name='search'])::before {
  content: '\\e93a';
}

:host([name='send'])::before {
  content: '\\e93b';
}

:host([name='cog'])::before {
  content: '\\e9b1';
}

:host([name='upload'])::before {
  content: '\\e93f';
}

:host([name='download'])::before {
  content: '\\e918';
}

:host([name='envelope'])::before {
  content: '\\e91a';
}

:host([name='home'])::before {
  content: '\\e91f';
}

:host([name='redo'])::before {
  content: '\\e920';
}

:host([name='list-alt'])::before {
  content: '\\e921';
}

:host([name='tasks-alt'])::before {
  content: '\\e938';
}

:host([name='cloud-download'])::before {
  content: '\\e926';
}

:host([name='maximize'])::before {
  content: '\\e9b8';
}

:host([name='minimize'])::before {
  content: '\\e9b9';
}

:host([name='square-a'])::before {
  content: '\\e9ba';
}

:host([name='square-1'])::before {
  content: '\\e9bb';
}

:host([name='square-link'])::before {
  content: '\\e9bc';
}

:host([name='square-poll-horizontal'])::before {
  content: '\\e9bd';
}

:host([name='square-ring'])::before {
  content: '\\e9be';
}

:host([name='square-check'])::before {
  content: '\\e9bf';
}

:host([name='square-chevron-down'])::before {
  content: '\\e9c0';
}

:host([name='sharing-plus'])::before {
  content: '\\e97e';
}

:host([name='wifi'])::before {
  content: '\\e974';
}

:host([name='blender'])::before {
  content: '\\e964';
}

:host([name='stroopwafel'])::before {
  content: '\\e965';
}

:host([name='print'])::before {
  content: '\\e966';
}

:host([name='binoculars'])::before {
  content: '\\e967';
}

:host([name='sleigh'])::before {
  content: '\\e968';
}

:host([name='suitcase'])::before {
  content: '\\e969';
}

:host([name='chair'])::before {
  content: '\\e96a';
}

:host([name='dice'])::before {
  content: '\\e96b';
}

:host([name='balance-scale'])::before {
  content: '\\e96c';
}

:host([name='table-tennis'])::before {
  content: '\\e96d';
}

:host([name='bicycle'])::before {
  content: '\\e96e';
}

:host([name='guitar'])::before {
  content: '\\e96f';
}

:host([name='mask'])::before {
  content: '\\e970';
}

:host([name='trailer'])::before {
  content: '\\e971';
}

:host([name='kite'])::before {
  content: '\\e972';
}

:host([name='pie'])::before {
  content: '\\e973';
}

:host([name='newspaper1'])::before {
  content: '\\e975';
}

:host([name='projector'])::before {
  content: '\\e976';
}

:host([name='lights-holiday'])::before {
  content: '\\e977';
}

:host([name='books'])::before {
  content: '\\e978';
}

:host([name='tools'])::before {
  content: '\\e979';
}

:host([name='box-full'])::before {
  content: '\\e97a';
}

:host([name='campground'])::before {
  content: '\\e97b';
}

:host([name='edge'])::before {
  content: '\\e99f';
}

:host([name='opera'])::before {
  content: '\\e9a0';
}

:host([name='firefox'])::before {
  content: '\\e9a1';
}

:host([name='chrome'])::before {
  content: '\\e9a2';
}

:host([name='safari'])::before {
  content: '\\e9a3';
}

:host([name='twitter-square'])::before {
  content: '\\e9c1';
}

:host([name='facebook-square'])::before {
  content: '\\e9c4';
}

:host([name='whatsapp-square'])::before {
  content: '\\e9cd';
}

:host([name='instagram-square'])::before {
  content: '\\e9c5';
}

:host([name='linkedin'])::before {
  content: '\\e9c6';
}

:host([name='mountain-sun'])::before {
  content: '\\e93c';
}

:host([name='money-bill-1-wave'])::before {
  content: '\\e93e';
}

:host([name='square-info'])::before {
  content: '\\e941';
}

:host([name='circle-phone-flip'])::before {
  content: '\\e942';
}

:host([name='popcorn'])::before {
  content: '\\e944';
}

:host([name='megaphone'])::before {
  content: '\\e945';
}

:host([name='cloud-sun-rain'])::before {
  content: '\\e946';
}

:host([name='circle-star'])::before {
  content: '\\e949';
}

:host([name='list-check'])::before {
  content: '\\e94a';
}

:host([name='suitcase1'])::before {
  content: '\\e94b';
}

:host([name='calendar-lines'])::before {
  content: '\\e94c';
}

:host([name='gift'])::before {
  content: '\\e94d';
}

:host([name='camera'])::before {
  content: '\\e94f';
}

:host([name='sitemap'])::before {
  content: '\\e953';
}

:host([name='watch-fitness'])::before {
  content: '\\e958';
}

:host([name='taxi-bus'])::before {
  content: '\\e95d';
}

:host([name='puzzle'])::before {
  content: '\\e95e';
}

:host([name='lightbulb-on'])::before {
  content: '\\e95f';
}

:host([name='plane'])::before {
  content: '\\e981';
}

:host([name='house-chimney'])::before {
  content: '\\e982';
}

:host([name='flask-vial'])::before {
  content: '\\e983';
}

:host([name='graduation-cap'])::before {
  content: '\\e985';
}

:host([name='screwdriver-wrench'])::before {
  content: '\\e986';
}

:host([name='paw'])::before {
  content: '\\e987';
}

:host([name='music'])::before {
  content: '\\e99c';
}

:host([name='baby-carriage'])::before {
  content: '\\e9a8';
}

:host([name='award'])::before {
  content: '\\e9af';
}

:host([name='champagne-glasses'])::before {
  content: '\\e9b2';
}

:host([name='plate-utensils'])::before {
  content: '\\e9b3';
}

:host([name='books1'])::before {
  content: '\\e9b4';
}

:host([name='bolt-lightning'])::before {
  content: '\\e9b5';
}

:host([name='balloon'])::before {
  content: '\\e9b6';
}

:host([name='apartment'])::before {
  content: '\\e9b7';
}
`;
export default styles;
